<!-- src/components/Slider.vue -->
<template>
	<div>
		<template v-if="isAllowed">
			<div style="overflow: hidden; background-color: #fff">
				<div class="row border-bottom" style="background-color: #fff;">
					<div class="col-auto  d-flex justify-content-center align-items-center">
						<a class="navbar-brand m-0" href="#" style="padding:0.0rem 1.0rem;">
							<img src="@/assets/img/ptpr_sidenav_bg.png" width="25" class="navbar-brand-img h-100" alt="...">
							<span v-if="true" class="ms-1 font-weight-normal pl-2">Pertamina Retail</span>
						</a>
					</div>
					<div class="col">
						<!-- Tombol Navigasi dengan Label di atas -->
						<div class="buttons-container">
							<button class="nav-button" :class="{ active: currentSlideIndex === 0 }" @click="goToSlide(0)">
								Sales Achievement
							</button>
							<button class="nav-button" :class="{ active: currentSlideIndex === 1 }" @click="goToSlide(1)">
								Sales Tracking
							</button>
							<button class="nav-button" :class="{ active: currentSlideIndex === 2 }" @click="goToSlide(2)">
								Fuel
							</button>
							<button class="nav-button" :class="{ active: currentSlideIndex === 3 }" @click="goToSlide(3)">
								TAC Unit
							</button>
							<button class="nav-button" :class="{ active: currentSlideIndex === 4 }" @click="goToSlide(4)">
								Store
							</button>
							<button class="nav-button" :class="{ active: currentSlideIndex === 5 }" @click="goToSlide(5)">
								LPG
							</button>
							<button class="nav-button" :class="{ active: currentSlideIndex === 6 }" @click="goToSlide(6)">
								Cafe
							</button>
						</div>
					</div>

					<div class="col-auto d-flex justify-content-center align-items-center">
						<el-button icon="el-icon-s-tools" size="mini" class="mr-3" @click="toggleSettings" circle></el-button>

					</div>

				</div>

				<div class="row">
					<div class="col-md-12">
						<div>
							<!-- Konten Slider yang bergeser -->
							<div class="slider-wrapper">
								<div class="slider" :style="sliderStyle">
									<!-- Komponen Slide Manual -->
									<div class="slide"><SalesTracking :interval-duration="intervalDuration" :auto-request-active="autoRequestActive" /></div>
									<div class="slide"><SalesTrackingChart :interval-duration="intervalDuration" :auto-request-active="autoRequestActive" /></div>
									<div class="slide"><OverviewFuel :interval-duration="intervalDuration" :auto-request-active="autoRequestActive" /></div>
									<div class="slide"><OverviewStationTACGrowthQuantityByRegion :interval-duration="intervalDuration" :auto-request-active="autoRequestActive" /></div>
									<div class="slide"><OverviewStore :interval-duration="intervalDuration" :auto-request-active="autoRequestActive" /></div>
									<div class="slide"><OverviewLpg :interval-duration="intervalDuration" :auto-request-active="autoRequestActive" /></div>
									<div class="slide"><OverviewCafe :interval-duration="intervalDuration" :auto-request-active="autoRequestActive" /></div>
								</div>
							</div>

							<!-- Tombol Next dan Previous di bawah slider -->
							<div class="nav-buttons" v-if="false">
								<button @click="previousSlide">Previous</button>
								<button @click="nextSlide">Next</button>
							</div>
						</div>
					</div>
				</div>

				<el-drawer title="Setting" :visible.sync="drawer" :direction="direction" :before-close="handleClose">
					<hr class="m-0 mb-4"/>
					<div class="mx-4">
						<h5>Slider</h5>
						<div class="row">
							<div class="col-md-12 mb-4">
								<span>Auto Slide:</span><br>
								<el-checkbox v-model="autoSlideActive" class="mr-4">{{ autoSlideActive ? 'Active':'Disabled' }}</el-checkbox>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 mb-4">
								<span>Slide Duration:</span><br>
								<div class="block ml-1">
									<el-slider :min="1" :max="120" v-model="slideDuration" @change="updateSlideDuration" show-input></el-slider>
								</div>
								<span>{{ slideDuration }} Seconds</span>
								<input v-if="false" type="range" id="slideDuration" min="1" max="120" v-model="slideDuration" @change="updateSlideDuration"/>

							</div>
						</div>

						<h5>Interval Data Request</h5>
						<div class="row">
							<div class="col-md-12 mb-4">
								<span>Auto Request:</span><br>
								<el-checkbox v-model="autoRequestActive" class="mr-4">{{ autoRequestActive ? 'Active':'Disabled' }}</el-checkbox>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12 mb-4">
								<span>Interval Duration:</span><br>
								<div class="block ml-1">
									<el-slider :min="1" :max="120" v-model="intervalDuration" @change="updateIntervalDuration" show-input></el-slider>
								</div>
								<span>{{ intervalDuration }} Seconds</span>
								<input v-if="false" type="range" id="intervalDuration" min="1" max="120" v-model="intervalDuration" @change="updateIntervalDuration"/>

							</div>
						</div>
					</div>
				</el-drawer>

			</div>
		</template>
		<template v-else>
			<div v-if="!loading.auth">
				<div class="d-flex justify-content-center align-items-center vh-100">
					<div class="row text-center">
						<div><i class="el-icon-circle-close text-danger" style="font-size:100px;"></i></div>
						<div class="display-block"><h2>We are Sorry...</h2></div>
						<p>The page you're trying to access has restricted access.<br>Please refer to your system administrator</p>
					</div>
				</div>
			</div>
		</template>
		<Loader v-if="loading.auth" />
	</div>
</template>

<script>
import { Rainbow, FuelColor, AppColors, Config, Penanggalan, AxiosWithJar } from '@/utility.js'
import SalesTracking from './Component/SalesTracking.vue';
import SalesTrackingChart from './Component/SalesTrackingChart.vue';
import OverviewFuel from './Component/OverviewFuel.vue';
import OverviewStore from './Component/OverviewStore.vue';
import OverviewLpg from './Component/OverviewLpg.vue';
import OverviewCafe from './Component/OverviewCafe.vue';
//import OverviewStationTACGrowthQuantity from './Component/OverviewStationTACGrowthQuantity.vue';
import OverviewStationTACGrowthQuantityByRegion from './Component/OverviewStationTACGrowthQuantityByRegion.vue';
import Loader from '@/components/loader/Loader2.vue'

export default {
    components: {
		SalesTracking,
		SalesTrackingChart,
		OverviewFuel,
		OverviewStore,
		OverviewLpg,
		OverviewCafe,
		//OverviewStationTACGrowthQuantity,
        OverviewStationTACGrowthQuantityByRegion,
		Loader,
    },
    data() {
		return {
			currentSlideIndex: 0, // Menyimpan slide yang aktif
			autoSlideActive: true, // Status untuk mengontrol auto slide
			autoSlideInterval: null, // Interval untuk auto slide
			slideDuration: 20, // Durasi default auto slide (dalam detik)
			settingsVisible: false,

			//Interval api request
			intervalDuration: 60, // Durasi request interval default 30 detik
			autoRequestActive: true, // Status apakah auto request aktif atau tidak

			drawer: false,
			direction: 'rtl',

			isAllowed: false,

			loading: {
				auth: true,
			}
		};
    },
	mounted() {
		//this.autoSlide();
		this.checkAuth();

		if(this.isAllowed) {
			if (this.autoSlideActive) {
				this.startAutoSlide();
			}
		}
	},
	beforeDestroy() {
		// Hentikan auto slide ketika komponen dihancurkan
		this.stopAutoSlide();
	},
    computed: {
		sliderStyle() {
			return {
				transform: `translateX(-${this.currentSlideIndex * 100}%)`, // Geser ke kiri
				transition: 'transform 0.5s ease-in-out', // Animasi perpindahan antar slide
			};
		},
    },
	watch: {
		// Mengontrol Auto Slide saat checkbox berubah
		autoSlideActive(newValue) {
			if (newValue) {
				this.startAutoSlide(); // Mulai auto slide
			} else {
				this.stopAutoSlide(); // Hentikan auto slide
			}
		},
		// Mengupdate interval auto slide ketika durasi berubah
		slideDuration(newValue) {
			if (this.autoSlideActive) {
				this.updateSlideDuration();
			}
		},
		isAllowed() {
			if(this.isAllowed) {
				if (this.autoSlideActive) {
					this.startAutoSlide();
				}
			}
		},
	},
    methods: {
		// Navigasi ke slide berikutnya
		nextSlide() {
			if (this.currentSlideIndex < 6) {
				this.currentSlideIndex++;
			} else {
				this.currentSlideIndex = 0; // Jika di slide terakhir, kembali ke pertama
			}
		},
		// Navigasi ke slide sebelumnya
		previousSlide() {
			if (this.currentSlideIndex > 0) {
				this.currentSlideIndex--;
			} else {
				this.currentSlideIndex = 6; // Jika di slide pertama, kembali ke terakhir
			}
		},
		// Navigasi langsung ke slide tertentu berdasarkan klik tombol
		goToSlide(index) {
			this.currentSlideIndex = index;
		},
		// Slider otomatis setiap 5 detik
		autoSlide() {
			setInterval(this.nextSlide, this.slideDuration * 1000); // Interval 5 detik
		},
		startAutoSlide() {
			this.autoSlideInterval = setInterval(() => {
				this.nextSlide();
			}, this.slideDuration * 1000); // Auto slide setiap 5 detik
		},
		stopAutoSlide() {
			clearInterval(this.autoSlideInterval);
			this.autoSlideInterval = null;
		},
		updateSlideDuration() {
			if (this.autoSlideActive) {
				this.stopAutoSlide();
				this.startAutoSlide();
			}
		},
		toggleSettings() {
			this.settingsVisible = !this.settingsVisible;
			this.drawer = true;
		},
		handleClose(done) {
			done();
			/*
			this.$confirm('Are you sure you want to close this?')
			.then(_ => {
				done();
			})
			.catch(_ => {});
			*/
		},

		updateIntervalDuration() {

		},

		async checkAuth() {
			//
			this.urlRequestParams = Config().apiURL
			this.urlRequestParams += '/v1/log/whitelist?'

            //this.urlRequestParams += '&year='+this.year

            this.loading.auth = true;
			//this.loading.isSuccess = false;
			AxiosWithJar().get(this.urlRequestParams)
				.then((response)=>{
					console.log(JSON.stringify(response.data));
					let statusCode = response.data.code;
					if(statusCode == 200) {
						this.isAllowed = true;
					}
				})
				.catch(error => {
					console.log(error)
					//this.errored = true
					//error.response.data
				})
				.finally(() => {
					this.loading.auth = false;
				})
        },
    },
};
</script>

<style scoped>
/* Tombol Navigasi di atas slider */
.buttons-container {
    display: flex;
    justify-content: center;
	background: #fff;
    margin-bottom: 0px; /* Jarak antara tombol dan slider */
	padding: 8px 0px;
}

.nav-button {
    padding: 6px 12px;
    margin: 0 5px;
    background-color: #fff; /* #bbb */
    color: #ddd;
    border: none;
    cursor: pointer;
	transition: background-color 0.3s, color 0.5s, text-decoration 0.5s;
    font-weight: normal;
    font-size: 14px;
	border-radius: 4px;
}

.nav-button.active {
    /*background-color: #409EFF ; */ /*#333*/
	background-color: #fff; /* #1e90ff Biru ketika aktif */
	color: #1e90ff;
	text-decoration: underline; /* Garis bawah muncul saat aktif */
	text-underline-offset: 8px; /* Atur jarak garis bawah */
}

.nav-button:hover {
    background-color: #409EFF  /*#666*/;
	color:white;
	text-decoration: none;
}

.nav-buttons {
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
}

.nav-buttons button {
    padding: 10px 20px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    border: none;
    cursor: pointer;
}

.nav-buttons button:hover {
    background-color: rgba(0, 0, 0, 0.8);
}

/* Kontainer utama slider */
.slider-container {
    position: relative;
    width: 100%;
    max-width: 100%; /* Sesuaikan lebar slider */
    margin: 0 auto;
}

/* Kontainer untuk slide */
.slider-wrapper {
    overflow: hidden; /* Sembunyikan konten yang terlewati */
}

.slider {
    display: flex; /* Letakkan slide secara horizontal */
	align-items: flex-start; /* Ini memastikan setiap slide hanya mengambil tinggi sesuai kontennya */
	width: 100%;
}

.slide {
    min-width: 100%; /* Lebar slide 100% dari kontainer */
    box-sizing: border-box; /* Agar padding dan margin dihitung dalam ukuran */
    text-align: center;
    background-color: #fff; /* Warna latar belakang setiap slide */
    padding: 12px 12px;
	overflow-y: auto;
}

.settings-container {
  position: absolute;
  top: 10px;
  right: 10px;
}

.settings-icon {
	font-size: 24px;
	background-color: #1e90ff;
	color: white;
	padding: 10px;
	border: none;
	cursor: pointer;
	border-radius: 50%;
}

.settings-panel {
	background-color: rgba(0, 0, 0, 0.8);
	color: white;
	padding: 10px;
	border-radius: 5px;
	margin-top: 10px;
}

.settings-panel input[type="range"] {
	width: 100%;
}

.el-drawer__header {
	margin-bottom: 10px !important;
}
</style>
